module.exports = __webpack_public_path__ + "img/2.6ccd12c7.png";